 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_FRONT_MATTER from '@/components/html/03_Front_Matter'
 import HTML04_EPIGRAPH from '@/components/html/04_Epigraph'
 import HTML05_EPIGRAPH_1 from '@/components/html/05_Epigraph_1'
 import HTML06_FRONTISPIECE from '@/components/html/06_Frontispiece'
 import HTML07_CONTENTS from '@/components/html/07_CONTENTS'
 import HTML08_PREFACE from '@/components/html/08_Preface'
 import HTML09_PART_I__ON_MEMORY_AND_RECOLLECTI from '@/components/html/09_PART_I__ON_MEMORY_AND_RECOLLECTI'
 import HTML10_CHAPTER_1__MEMORY_AND_IMAGINATIO from '@/components/html/10_Chapter_1__Memory_and_Imaginatio'
 import HTML11_CHAPTER_2__THE_EXERCISE_OF_MEMOR from '@/components/html/11_Chapter_2__The_Exercise_of_Memor'
 import HTML12_CHAPTER_3__PERSONAL_MEMORY__COLL from '@/components/html/12_Chapter_3__Personal_Memory__Coll'
 import HTML13_PART_II__HISTORY__EPISTEMOLOGY from '@/components/html/13_PART_II__HISTORY__EPISTEMOLOGY'
 import HTML14_PRELUDE__HISTORY__REMEDY_OR_POIS from '@/components/html/14_Prelude__History__Remedy_or_Pois'
 import HTML15_CHAPTER_1__THE_DOCUMENTARY_PHASE from '@/components/html/15_Chapter_1__The_Documentary_Phase'
 import HTML16_CHAPTER_2__EXPLANATION_UNDERSTAN from '@/components/html/16_Chapter_2__Explanation_Understan'
 import HTML17_CHAPTER_3__THE_HISTORIAN_S_REPRE from '@/components/html/17_Chapter_3__The_Historian_s_Repre'
 import HTML18_PART_III__THE_HISTORICAL_CONDITI from '@/components/html/18_PART_III__THE_HISTORICAL_CONDITI'
 import HTML19_PRELUDE__THE_BURDEN_OF_HISTORY_A from '@/components/html/19_Prelude__The_Burden_of_History_a'
 import HTML20_CHAPTER_1__THE_CRITICAL_PHILOSOP from '@/components/html/20_Chapter_1__The_Critical_Philosop'
 import HTML21_CHAPTER_2__HISTORY_AND_TIME from '@/components/html/21_Chapter_2__History_and_Time'
 import HTML22_CHAPTER_3__FORGETTING from '@/components/html/22_Chapter_3__Forgetting'
 import HTML23_EPILOGUE__DIFFICULT_FORGIVENESS from '@/components/html/23_Epilogue__Difficult_Forgiveness'
 import HTML24_NOTES from '@/components/html/24_Notes'
 import HTML25_WORKS_CITED from '@/components/html/25_Works_Cited'
 import HTML26_INDEX from '@/components/html/26_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/07_CONTENTS",
 			"name" : "html/07_CONTENTS",
 			"component" : HTML07_CONTENTS
 		},
 		{
 			"path" : "/html/08_Preface",
 			"name" : "html/08_Preface",
 			"component" : HTML08_PREFACE
 		},
 		{
 			"path" : "/html/09_PART_I__ON_MEMORY_AND_RECOLLECTI",
 			"name" : "html/09_PART_I__ON_MEMORY_AND_RECOLLECTI",
 			"component" : HTML09_PART_I__ON_MEMORY_AND_RECOLLECTI
 		},
 		{
 			"path" : "/html/10_Chapter_1__Memory_and_Imaginatio",
 			"name" : "html/10_Chapter_1__Memory_and_Imaginatio",
 			"component" : HTML10_CHAPTER_1__MEMORY_AND_IMAGINATIO
 		},
 		{
 			"path" : "/html/11_Chapter_2__The_Exercise_of_Memor",
 			"name" : "html/11_Chapter_2__The_Exercise_of_Memor",
 			"component" : HTML11_CHAPTER_2__THE_EXERCISE_OF_MEMOR
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js